import { select } from "d3";

import {
  AppletElement,
  CATERPILLAR_DIAGRAM_HEIGHT,
  CATERPILLAR_DIAGRAM_WIDTH,
  CATERPILLAR_EDGE_STROKE,
  CATERPILLAR_NODE_STROKE,
  CATERPILLAR_STRUCTURE_EDGES,
  CATERPILLAR_STRUCTURE_NODES,
  CaterpillarDiagramEdge,
  CaterpillarDiagramNode,
  CaterpillarNodeKind,
  caterpillarEdgeEndpoints,
  caterpillarNodeFill,
  caterpillarNodeLookup,
  caterpillarNodeRadius,
  caterpillarNodeStrokeWidth,
  renderApplet,
  renderCaterpillarLegend,
} from "./common";

function renderCaterpillarStructure(element: AppletElement): void {
  element.dataset.rendered = "true";
  element.replaceChildren();

  const nodes = caterpillarNodeLookup();
  const svg = select<AppletElement, unknown>(element)
    .append<SVGSVGElement>("svg")
    .attr("viewBox", `0 0 ${CATERPILLAR_DIAGRAM_WIDTH} ${CATERPILLAR_DIAGRAM_HEIGHT}`)
    .attr("width", CATERPILLAR_DIAGRAM_WIDTH)
    .attr("height", CATERPILLAR_DIAGRAM_HEIGHT)
    .attr("role", "img")
    .attr("aria-label", "A caterpillar with spine vertices and leg vertices.");

  const graph = svg.append<SVGGElement>("g")
    .attr("class", "caterpillar-structure-graph");

  graph.append<SVGGElement>("g")
    .attr("class", "caterpillar-structure-edges")
    .selectAll<SVGLineElement, CaterpillarDiagramEdge>("line")
    .data(CATERPILLAR_STRUCTURE_EDGES)
    .join("line")
    .attr("x1", (edge: CaterpillarDiagramEdge): number => caterpillarEdgeEndpoints(edge, nodes).x1)
    .attr("y1", (edge: CaterpillarDiagramEdge): number => caterpillarEdgeEndpoints(edge, nodes).y1)
    .attr("x2", (edge: CaterpillarDiagramEdge): number => caterpillarEdgeEndpoints(edge, nodes).x2)
    .attr("y2", (edge: CaterpillarDiagramEdge): number => caterpillarEdgeEndpoints(edge, nodes).y2)
    .attr("stroke", CATERPILLAR_EDGE_STROKE)
    .attr("stroke-width", 1.4);

  graph.append<SVGGElement>("g")
    .attr("class", "caterpillar-structure-nodes")
    .selectAll<SVGCircleElement, CaterpillarDiagramNode>("circle")
    .data(CATERPILLAR_STRUCTURE_NODES)
    .join("circle")
    .attr("cx", (node: CaterpillarDiagramNode): number => node.x)
    .attr("cy", (node: CaterpillarDiagramNode): number => node.y)
    .attr("r", (node: CaterpillarDiagramNode): number => caterpillarNodeRadius(node.kind))
    .attr("fill", (node: CaterpillarDiagramNode): string => caterpillarNodeFill(node.kind))
    .attr("stroke", CATERPILLAR_NODE_STROKE)
    .attr("stroke-width", (node: CaterpillarDiagramNode): number => caterpillarNodeStrokeWidth(node.kind))
    .attr("data-node-kind", (node: CaterpillarDiagramNode): CaterpillarNodeKind => node.kind);

  renderCaterpillarLegend(svg);
}

renderApplet(".caterpillar-structure-applet", renderCaterpillarStructure);
